import {useEffect, useState} from 'react';

function useSettleWatchdog(isResolved: boolean, timeoutMs: number) {
  const [isFired, setIsFired] = useState(false);

  useEffect(() => {
    if (isResolved) {
      setIsFired(false);
      return;
    }

    const timeout = setTimeout(() => setIsFired(true), timeoutMs);
    return () => clearTimeout(timeout);
  }, [isResolved, timeoutMs]);

  return isFired && !isResolved;
}

export {useSettleWatchdog};
